import Loading from "components/Loading";
import Permission from "components/Permission";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import PermissionDeniedPage from "components/PermissionDenied";
import { MODULE_CATEGORY } from "shared/constants";

const CategoryHotDeal = React.lazy(
  () => import("containers/ServiceManagement/CategoryHotDeal")
);

function CategoryHotDealRoute() {
  return (
    <Route
      path="category-management"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<CategoryHotDeal />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_CATEGORY]}
          />
        </Suspense>
      }
    />
  );
}

export default CategoryHotDealRoute;
